import { motion } from "framer-motion";
import Reveal from "@/components/site/Reveal";
import { JOIN } from "@/constants/testIds";

const STEPS = [
  { title: "Apply & Get Approved", body: "Submit your application and get onboarded." },
  { title: "Get Trained", body: "Learn the programs, pitch strategies, and tools." },
  { title: "Start Referring", body: "Introduce SmartEdge to your network and qualified leads." },
  { title: "Earn Residual Income", body: "Get paid monthly on every active client account." },
];

export default function ProcessSection() {
  return (
    <section
      data-testid={JOIN.process}
      className="section-pad"
      style={{ background: "var(--color-bg-soft)" }}
    >
      <div className="container-wide" style={{ textAlign: "center" }}>
        <Reveal>
          <div className="eyebrow mb-5" style={{ justifyContent: "center" }}>
            The process
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="type-section-heading mb-16">
            Simple. Supported. Scalable.
          </h2>
        </Reveal>

        <div className="timeline" style={{ maxWidth: 1080, margin: "0 auto" }}>
          <div className="hidden md:block timeline__line" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 relative">
            {STEPS.map((s, i) => (
              <Reveal
                key={s.title}
                delay={i * 0.12}
                y={20}
                className="flex md:block gap-5 md:gap-0 items-start"
                style={{ textAlign: "left" }}
              >
                <motion.div
                  className="timeline__num md:mx-auto"
                  initial={{ scale: 0.6, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{
                    delay: 0.15 + i * 0.12,
                    duration: 0.5,
                    ease: [0.34, 1.56, 0.64, 1],
                  }}
                >
                  {String(i + 1).padStart(2, "0")}
                </motion.div>
                <div className="md:text-center md:mt-6 flex-1">
                  <h3
                    className="type-subheading mb-2"
                    style={{ fontSize: 18, fontWeight: 500, color: "var(--color-heading)" }}
                  >
                    {s.title}
                  </h3>
                  <p
                    className="type-body"
                    style={{ fontSize: 14, maxWidth: 220, margin: "0 auto" }}
                  >
                    {s.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
